const getPagination = (current: number, last: number) => {
  const range = [] // https://codepen.io/alwang85/pen/dyOwYXV

  if (last <= 9) {
    for (let i = 1; i <= last; i++) {
      range.push(i)
    }
  } else if (current <= 3) {
    range.push(...[1, 2, 3, 4, '...'])
    for (let i = last - 3; i <= last; i++) {
      range.push(i)
    }
  } else if (current > last - 3) {
    range.push(1, 2, 3, 4, '...')
    for (let i = last - 3; i <= last; i++) {
      range.push(i)
    }
  } else {
    range.push(1, '...')
    for (let i = current - 2; i <= current + 2; i++) {
      range.push(i)
    }

    range.push('...', last)
  }

  return range
}

export default getPagination
